module.exports = __webpack_public_path__ + "img/6c.bf6e8aa7.png";